import { Toaster } from "sonner";
import { RouteManager } from "./RouteManager";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <>
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <RouteManager />
      </BrowserRouter>
    </>
  );
}

export default App;
